export default (opt = {}) => {
    let editor = opt.editor,
        styleManager = editor.StyleManager;

    /**
     * @param {object} props
     * @param {string} props.text
     * @param {function} props.cb callback function to execute on click. Gets selected component, button HTML Element, and click event passed as parameters.
     * @param {grapesjs.Component} props.component
     * @param {string} [props.iconClass]
     * @param {string} [props.btnClass]
     */
    styleManager.addType(window.PMW.emails.styles.ID_CTA_BUTTON, {
        create({props}) {
            let el;

            if (typeof props.buttons !== 'undefined' && Array.isArray(props.buttons)) {
                el = document.createElement('div');
                el.className = 'flex-v-row button-group-container';

                props.buttons.forEach((buttonProp) => {
                    let btn = createCtaButton(buttonProp);
                    el.appendChild(btn);
                });
            } else {
                el = createCtaButton(props);
            }

            return el;
        },
    });

    /**
     * @param {object} props
     * @param {string} props.text
     * @param {function} props.cb callback function to execute on click. Gets selected component, button HTML Element, and click event passed as parameters.
     * @param {grapesjs.Component} props.component
     * @param {string} [props.iconClass]
     * @param {string} [props.btnClass]
     */
    function createCtaButton(props) {
        const button = document.createElement('button'),
            icon = document.createElement('i'),
            text = document.createElement('span');

        if (typeof props.cb === 'undefined') {
            props.cb = function () {
            };
        }

        props.component = props.component || editor.getSelected();
        text.innerHTML = props.text;
        text.className = `btn-text js-cta-text`;
        button.className = `${props.type} btn small ${props.btnClass || ''}`;
        if (props.iconClass) {
            icon.className = `btn-icon size-icon-24 ${props.iconClass || ''}`;
            button.appendChild(icon);
        }

        button.appendChild(text);
        button.addEventListener('click', props.cb.bind(this, editor, props.component, button));

        return button;
    }
}